import { createContext, useContext } from "react";

interface IRoleContext {
  pages: string[];
  // permissions: { page: string; permissions: string[] }[];
  permissions: { [key in string]: string[] };
  role: string;
  isLoading: boolean;
  setPermissionsAndPages: (data: any) => void;
  getPermits: (page: string) => {
    canEdit: boolean;
    canDelete: boolean;
    canCreate: boolean;
    canRead?: boolean;
  };
}

export const initialState: IRoleContext = {
  pages: [],
  permissions: {},
  role: "",
  isLoading: true,
  setPermissionsAndPages: () => {},
  getPermits: () => ({
    canEdit: false,
    canDelete: false,
    canCreate: false,
    canRead: false,
  }),
};

const RoleContext = createContext(initialState);

export const useRole = () => {
  return useContext(RoleContext);
};

export default RoleContext;
